import { jsx as s } from "react/jsx-runtime";
import { a as n, useSpring as f } from "@react-spring/web";
import { Ui as m } from "../Ui/Ui.js";
function i({ children: o, delay: t = 0 }) {
  const r = i.useShowAfter(t);
  return /* @__PURE__ */ s(n.div, { style: r, children: o });
}
((o) => {
  function t(r) {
    const e = m.useUi(!0);
    return f({
      config: {
        friction: 80,
        mass: 2,
        tension: 2e3
      },
      delay: r,
      from: { opacity: 0, transform: "scale(0.97)" },
      immediate: e == null ? void 0 : e.reducedMotion,
      to: { opacity: 1, transform: "scale(1)" }
    });
  }
  o.useShowAfter = t;
})(i || (i = {}));
export {
  i as ShowAfter
};
//# sourceMappingURL=ShowAfter.js.map
